import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { OrganizationRole } from "../../common/models/organization-role";
import { User } from "../../common/models/user";
import { Session } from "../../common/models/session";
import { Timeslot } from "../../common/models/timeslot";
import { Agenda } from "../../common/models/agenda";
import { Athlete } from "../../common/models/athlete";
import { AthleteCoach } from "../../common/models/athlete-coach";
import { Coach } from "../../common/models/coach";
import { OrganizationMembership } from "../../common/models/organization-membership";
import { Library } from "../../common/models/library";
import { CoachItemRightsList } from "../../coaches/providers/coaches-rights";

export class SessionRights {
    public Ready: Promise<boolean> = new Promise<boolean>((resolve, reject) => resolve(false));
    private _itemRightsList: SessionItemRightsList | null= null;
    private _screenRightsList: SessionScreenRightList | null = null;
    private _paramsItem: SessionItemRightsParams | null = null;
    private _paramsScreen: SessionScreenRightsParams | null = null;
    private _bestOfItemRight = 10000;
    private _bestOfScreenRight = 10000;
    constructor(private _utils: UtilsProvider) {
        this.setDefault();
    }

    public evaluateItemRight(params: SessionItemRightsParams): void {

        /**
         * Les paramètres reçus contiennent le session, le user.id
         * et le organizationId. Les droits évalués doivent répondrent
         * à la question : qu'est-ce que je (user.id) peux faire avec
         * cette session (session.id) dans cette organisation (organizationId)
         * avec mon rôle (this._bestOfItemRight).
         */

        this._paramsItem = params;
        this.setDefault();
        this.setBestOfRole();

        const session = this._paramsItem.session;
        let library = null;
        let agendas = null;
        let timeslots = null;
        let agendaIds = null;
        let sessionIds = null;
        const coachs = null;
        const coachIds = null;
        const links = null;
        let athleteIds = null;
        const coach = null;
        let memberships = null;
        let userIds = null;
        let athletes = null;

        if (!this._itemRightsList) return;

        switch (this._bestOfItemRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            // toutes les sessions
            this._itemRightsList.view = true;
            this._itemRightsList.edit = true;
            this._itemRightsList.delete = true;
            this._itemRightsList.duplicate = true;
            this._itemRightsList.terminate = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un supercoach
            // toutes les séances de son organisation et toutes les
            // séances des calendriers de ses athlètes de ses organisations
            if (session.libraryId) {
                library = this._utils.findIn(session.libraryId, this._paramsItem.libraries, 'id');
                if (library?.ownerOrganizationId === this._paramsItem.organizationId) {
                    this._itemRightsList.view = true;
                    this._itemRightsList.edit = true;
                    this._itemRightsList.delete = true;
                    this._itemRightsList.duplicate = true;
                    this._itemRightsList.terminate = false;
                }
            }
            memberships = this._utils.findManyIn([this._paramsItem.organizationId], this._paramsItem.athleteMemberships, 'organizationId');
            userIds = this._utils.getKeyValues(memberships, 'userId');
            athletes = this._utils.findManyIn(userIds, this._paramsItem.athletes, 'userId');
            athleteIds = this._utils.getKeyValues(athletes, 'id');
            agendas = this._utils.findManyIn(athleteIds, this._paramsItem.agendas, 'athleteId');
            agendaIds = this._utils.getKeyValues(agendas, 'id');
            timeslots = this._utils.findManyIn(agendaIds, this._paramsItem.timeslots, 'agendaId');
            sessionIds = this._utils.getKeyValues(timeslots, 'sessionId');
            if (sessionIds.indexOf(this._paramsItem.session.id) > -1){
                this._itemRightsList.view = true;
                this._itemRightsList.edit = true;
                this._itemRightsList.delete = true;
                this._itemRightsList.duplicate = true;
                this._itemRightsList.terminate = false;
            }
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            // voir et dupliquer toutes les séances de son organisation et toutes les
            // séances des calendriers de ses athlètes
            if (session.libraryId) {
                library = this._utils.findIn(session.libraryId, this._paramsItem.libraries, 'id');
                if (library.ownerOrganizationId === this._paramsItem.organizationId) {
                    this._itemRightsList.view = true;
                    this._itemRightsList.duplicate = true;
                }
            }
            memberships = this._utils.findManyIn([this._paramsItem.organizationId], this._paramsItem.athleteMemberships, 'organizationId');
            userIds = this._utils.getKeyValues(memberships, 'userId');
            athletes = this._utils.findManyIn(userIds, this._paramsItem.athletes, 'userId');
            athleteIds = this._utils.getKeyValues(athletes, 'id');
            agendas = this._utils.findManyIn(athleteIds, this._paramsItem.agendas, 'athleteId');
            agendaIds = this._utils.getKeyValues(agendas, 'id');
            timeslots = this._utils.findManyIn(agendaIds, this._paramsItem.timeslots, 'agendaId');
            sessionIds = this._utils.getKeyValues(timeslots, 'sessionId');
            if (sessionIds.indexOf(this._paramsItem.session.id) > -1){
                this._itemRightsList.view = true;
                this._itemRightsList.edit = true;
                this._itemRightsList.delete = true;
                this._itemRightsList.duplicate = true;
                this._itemRightsList.terminate = false;
            }
            break;

        case OrganizationRole.ID_ATHLETE:
            // this._paramsItem.user est un athlète
            // voir toutes les séances de ses agendas
            const athlete = this._utils.findIn(this._paramsItem.user.id, this._paramsItem.athletes, 'userId');
            agendas = this._utils.findManyIn([athlete.id], this._paramsItem.agendas, 'athleteId');
            agendaIds = this._utils.getKeyValues(agendas, 'id');
            timeslots = this._utils.findManyIn(agendaIds, this._paramsItem.timeslots, 'agendaId');
            sessionIds = this._utils.getKeyValues(timeslots, 'sessionId');

            if (sessionIds.indexOf(session.id) > -1 ) {

                // c'est une session qui fait partie de ses agendas
                this._itemRightsList.view = true;
                this._itemRightsList.terminate = true;
            } else {

                // en dernier recours, voir toutes les séances de son organisation
                if (session.libraryId) {
                    library = this._utils.findIn(session.libraryId, this._paramsItem.libraries, 'id');
                    if (library.ownerOrganizationId === this._paramsItem.organizationId) {
                        this._itemRightsList.view = true;
                    }
                }
            }
            break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            // toutes les séances de son organisation
            if (session.libraryId) {
                library = this._utils.findIn(session.libraryId, this._paramsItem.libraries, 'id');
                if (library.ownerOrganizationId === this._paramsItem.organizationId) {
                    this._itemRightsList.view = true;
                }
            }
            break;

        default:
            // rien
        }
    }

    public evaluateScreenRights(params: SessionScreenRightsParams): void {

        /**
         * Détermine les droits que l'utilisateur possède
         * pour les commandes générales des écrans.
         */

        this._paramsScreen = params;
        this.setDefault();
        this.setBestOfRole();

        if (!this._screenRightsList) return;

        switch (this._bestOfScreenRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un super-coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_ATHLETE:
            // this._paramsItem.user est un athlète
            this._screenRightsList.list = true;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = false;
            this._screenRightsList.delete = false;
            break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            this._screenRightsList.list = false;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = false;
            this._screenRightsList.delete = false;
            break;

        default:
            // rien
        }
    }

    public getItemRightsList(): SessionItemRightsList {
        if (!this._itemRightsList) throw new Error('SessionRights: itemRightsList is null');
        return this._itemRightsList;
    }

    public getScreenRightsList(): SessionScreenRightList {
        if (!this._screenRightsList) throw new Error('SessionRights: screenRightsList is null');
        return this._screenRightsList;
    }

    public getItemParams(): SessionItemRightsParams {
        if(!this._paramsItem) throw new Error('SessionRights: itemParams is null');
        return this._paramsItem;
    }

    public getScreenParams(): SessionScreenRightsParams {
        if(!this._paramsScreen) throw new Error('SessionRights: screenParams is null');
        return this._paramsScreen;
    }

    public get LIST() {
        if (this._screenRightsList) {
            return this._screenRightsList.list;
        }
        return false;
    }

    public get ADD() {
        if (this._screenRightsList) {
            return this._screenRightsList.add;
        }
        return false;
    }

    public get EDIT() {
        if (this._screenRightsList) {
            return this._screenRightsList.edit;
        }
        return false;
    }

    public get DELETE() {
        if (this._screenRightsList) {
            return this._screenRightsList.delete;
        }
        return false;
    }

    private setDefault(): void {

        const defaultItemRights: SessionItemRightsList = {
            view: false,
            edit: false,
            duplicate: false,
            delete: false,
            terminate: false,
        };
        this._itemRightsList = defaultItemRights;

        const defaultScreenRights: SessionScreenRightList = {
            list: false,
            add: false,
            edit: false,
            delete: false,
        };
        this._screenRightsList = defaultScreenRights;

        this._bestOfItemRight = 10000;
        this._bestOfScreenRight = 10000;
    }

    private setBestOfRole() {

        if (this._paramsItem && this._paramsItem.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsItem.rolesIds.length; i++) {
                if (this._paramsItem.rolesIds[i] < this._bestOfItemRight) {
                    this._bestOfItemRight = this._paramsItem.rolesIds[i];
                }
            }
        }

        if (this._paramsScreen && this._paramsScreen.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsScreen.rolesIds.length; i++) {
                if (this._paramsScreen.rolesIds[i] < this._bestOfScreenRight) {
                    this._bestOfScreenRight = this._paramsScreen.rolesIds[i];
                }
            }
        }
    }
}

export interface SessionItemRightsList {
  view: boolean;
  edit: boolean;
  duplicate: boolean;
  delete: boolean;
  terminate: boolean;
}

const defaultRights: SessionItemRightsList = {
  view: false,
  edit: false,
  duplicate: false,
  delete: false,
  terminate: false,
}

export function mapSessionRightsToRowRights(sessionRights: string []): SessionItemRightsList {
  const rights = { ...defaultRights };

  sessionRights.forEach((right: string) => {
    if (right in rights) {
      rights[right as keyof SessionItemRightsList] = true;
    }
  });

  return rights;
}



export interface SessionScreenRightList {
    list: boolean;
    add: boolean;
    edit: boolean;
    delete: boolean;
}

export interface SessionItemRightsParams {
    user: User;
    organizationId: number;
    session: Session;
    rolesIds: number[];
    timeslots: Timeslot[];
    agendas: Agenda[];
    athletes: Athlete[];
    libraries: Library[];
    athleteCoachRelations: AthleteCoach[];
    coaches: Coach[];
    athleteMemberships: OrganizationMembership[];
}

export interface SessionScreenRightsParams {
    rolesIds: number[];
}
